module.exports = __webpack_public_path__ + "img/p1_bg.e35722a2.jpg";